(() => {
  const lpPath = '/pages/yamma-2026';
  const lpLocation = 'https://kaede-nachi.com' + lpPath;
  const linkEvents = {
    '#access': ['yamma_access_click', 'visit_guide', lpLocation + '#access'],
    '/pages/contact': ['yamma_contact_click', 'contact', 'https://kaede-nachi.com/pages/contact'],
    '/': ['yamma_home_click', 'home', 'https://kaede-nachi.com/'],
  };

  // Reuse the official Google tag. Never create another tag or change consent.
  if (window.location.pathname === lpPath && !window.Shopify?.customerPrivacy) {
    try {
      window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], () => {});
    } catch {
      // Keep the photo dialog working if Shopify's loader is unavailable.
    }
  }

  const trackLink = (event, root) => {
    if (window.location.pathname !== lpPath || window.Shopify?.designMode || event.defaultPrevented) return;
    const link = event.target.closest('a[href]');
    if (!link || !root.contains(link)) return;
    const href = link.getAttribute('href');
    if (!Object.hasOwn(linkEvents, href)) return;
    // Maps and yamma.jp already use GA4's outbound click; do not duplicate it.
    try {
      const privacy = window.Shopify?.customerPrivacy;
      if (
        privacy?.currentVisitorConsent?.().analytics !== 'yes' ||
        privacy?.analyticsProcessingAllowed?.() !== true ||
        typeof window.gtag !== 'function'
      ) {
        return;
      }
      const [name, label, destination] = linkEvents[href];
      window.gtag('event', name, {
        send_to: 'G-DRYP54MXG2',
        link_id: label,
        link_url: destination,
        page_location: lpLocation,
        page_referrer: '',
        page_title: 'Yamma 2026',
      });
    } catch {
      // A missing consent API/tag must never interrupt normal navigation.
    }
  };

  const initialize = (container = document) => {
    const roots = container.matches?.('[data-yamma-lp]') ? [container] : container.querySelectorAll('[data-yamma-lp]');
    for (const root of roots) {
      if (root.dataset.yammaReady) continue;
      root.dataset.yammaReady = 'true';
      root.addEventListener('click', (event) => trackLink(event, root));
      const dialog = root.querySelector('.photo-dialog');
      const image = dialog.querySelector('img');
      const caption = dialog.querySelector('figcaption');
      let trigger;
      root.addEventListener('click', (event) => {
        const link = event.target.closest('[data-photo]');
        if (!link || !root.contains(link) || !dialog.showModal) return;
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        trigger = link;
        image.src = link.href;
        image.alt = link.querySelector('img').alt;
        caption.textContent = link.closest('figure').querySelector('figcaption').textContent;
        dialog.showModal();
      });
      dialog.querySelector('.dialog-close').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog || event.target === dialog.querySelector('figure')) dialog.close();
      });
      dialog.addEventListener('close', () => {
        image.removeAttribute('src');
        if (trigger?.isConnected) trigger.focus({ preventScroll: true });
      });
    }
  };
  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
